var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlechaMobil14Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 17,
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    clipPath: "url(#clip0_1265_4081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.86906 16.5001C1.63906 16.5001 1.41906 16.4101 1.23906 16.2401C0.889062 15.8901 0.889062 15.3301 1.23906 14.9801L7.70906 8.48006L1.23906 2.02006C0.889062 1.67006 0.889062 1.11006 1.23906 0.760059C1.58906 0.410059 2.14906 0.410059 2.49906 0.760059L9.58906 7.86006C9.93906 8.21006 9.93906 8.77006 9.58906 9.12006L2.49906 16.2401C2.32906 16.4101 2.09906 16.5001 1.86906 16.5001Z",
    fill: "#2C353C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1265_4081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.87,
    height: 16,
    fill: "white",
    transform: "translate(0.980469 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlechaMobil14Px);
export default __webpack_public_path__ + "static/media/flecha_mobil_14px.aada0d47bcf543758ed8a41439061ce7.svg";
export { ForwardRef as ReactComponent };